import V1PaymentPage from '@/pages/v1/checkout/PaymentPage'
import V2PaymentPage from '@/pages/v2/checkout/PaymentPage'
import { getABTestVariantFromContext } from '@app-studio-web/ui/helpers/variantContext'
import BaselinePaymentPage from '@app-studio-web/ui/pages/checkout/PaymentPage'

// `createStripeSubscriptionAction` redirects to /checkout/payment regardless of
// which plans page the purchase started from, so the payment step cannot sit
// behind a variant path prefix like the plans page does. It is mounted once and
// picks its own layout from the resolved variant instead. All three read the
// same loader data and search params, so switching between them is safe.
export default function VariantPaymentPage() {
  switch (getABTestVariantFromContext()) {
    case 'v1':
      return <V1PaymentPage />
    case 'v2':
      return <V2PaymentPage />
    default:
      return <BaselinePaymentPage />
  }
}
